const initialState = {
  resultsExtraList: [],
  resultsExtra: {},
  resultsExtraAdd: {},
  resultsExtraPatch: {},
  resultsExtraDelete: {},
  resultsExtraProductAdd: {},
  resultsExtraProducts: [],
  resultsExtraProductsDelete: {},
  resultsExtrasTaxesAdd: {},
  resultsExtrasTaxesDelete: {},
};

const reducer = (state = initialState, action) => {
  const newState = { ...state };

  switch (action.type) {
    case "LIST_EXTRA_RESPONSE_GET":
      newState.resultsExtraList = action.value;
      break;
    case "EXTRA_RESPONSE_GET":
      newState.resultsExtra = action.value;
      break;
    case "EXTRA_RESPONSE_RESET":
      newState.resultsExtra = {};
      break;
    case "EXTRA_RESPONSE_ADD":
      newState.resultsExtraAdd = action.value;
      break;
    case "EXTRA_RESPONSE_UPDATE":
      newState.resultsExtraPatch = action.value;
      break;
    case "EXTRA_RESPONSE_DELETE":
      newState.resultsExtraDelete = action.value;
      break;
    case "EXTRA_PRODUCT_RESPONSE_ADD":
      newState.resultsExtraProductAdd = action.value;
      break;
    case "EXTRA_PRODUCTS_RESPONSE_GET":
      newState.resultsExtraProducts = action.value;
      break;
    case "EXTRA_PRODUCTS_RESPONSE_DELETE":
      newState.resultsExtraProductsDelete = action.value;
      break;
    case "EXTRAS_PRODUCT_RESPONSE_ADD":
      newState.resultsExtrasProductAdd = action.value;
      break;
    case "EXTRAS_PRODUCT_RESPONSE_DELETE":
      newState.resultsExtrasProductDelete = action.value;
      break;
    case "EXTRAS_TAXES_RESPONSE_ADD":
      newState.resultsExtrasTaxesAdd = action.value;
      break;
    case "EXTRAS_TAXES_RESPONSE_DELETE":
      newState.resultsExtrasTaxesDelete = action.value;
      break;
    case "RESET_EXTRA_RESPONSES":
      newState.resultsExtraAdd = {};
      newState.resultsExtraPatch = {};
      newState.resultsExtraDelete = {};
      newState.resultsExtraProductAdd = {};
      newState.resultsExtraProductsDelete = {};
      newState.resultsExtrasTaxesAdd = {};
      newState.resultsExtrasTaxesDelete = {};

      break;
    default:
      break;
  }
  return newState;
};

export default reducer;
